export default{
    tomador:'',
}